<template lang="pug">
  article(:class="{ 'c-lst-port-pw': isLocked }")
    nuxt-link(:to="`/w/${content.id}`")
      .c-lst-port-thumb
        img(v-lazy="content.image_url")
      item-info(:content="content")
    item-detail(:content="content")
</template>
<script>
import ItemInfo from '~/components/portfolios/ItemInfo'
import ItemDetail from '~/components/portfolios/ItemDetail'

export default {
  components: {
    ItemInfo,
    ItemDetail
  },
  props: {
    content: {
      type: Object,
      required: true
    }
  },
  computed: {
    isLocked() {
      return this.locked && this.content.user.id !== this.$auth.user.id
    }
  }
}
</script>
